import type { ResolveMainBoard } from "./types";

export const resolveMainBoard: ResolveMainBoard = ({ answer, suggestion, isLive }) => {
  const liveSuggestion = suggestion && isLive(suggestion.label) ? suggestion : null;
  // The surveyor's note outranks everything, including the estimator's own pick (KARL.md precedence).
  if (liveSuggestion?.from === "note") return { kind: "note", label: liveSuggestion.label };
  if (answer && isLive(answer.label)) {
    return { kind: "answered", label: answer.label, by: answer.by };
  }
  if (liveSuggestion) {
    return { kind: "suggested", label: liveSuggestion.label, from: liveSuggestion.from };
  }
  return { kind: "none" };
};
